'use client';

export { default } from './Table';
export * from './tableClasses';
export { default as tableClasses } from './tableClasses';
export * from './TableProps';